import { CheckoutSummaryCommonQuestions } from 'components/views/pages/Checkout/CheckoutSummary/components/CheckoutSummaryCommonQuestions';
import { SummaryLayout } from 'components/views/pages/Checkout/CheckoutSummary/SummaryLayout';

interface Props {
  pid: string | undefined;
  isLoading: boolean;
}

export const ContactSummary = ({ pid, isLoading }: Props) => {
  return (
    <SummaryLayout pid={pid}>
      <CheckoutSummaryCommonQuestions
        isLoading={isLoading}
        pid={pid}
      />
    </SummaryLayout>
  );
};
